import "./not-found.scss"

function NotFound() {

    const statusMessage = "Unexpected error while loading page. Please try again later"

    return (
        <div>
            <div className="error-message">
                <img src="/Samples/page-error.png" style={{width: "8em", height: "10em", paddingBottom: "2em"}}/>
                <h3 className="error-message-text">{statusMessage}</h3>
                <h3 className="error-message-text">Please open this link to visit <a href="/">homepage</a>.</h3>
            </div>
        </div>
    );
}

export default NotFound;